"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const monocle = require("monocle-ts");
const fp = require("fp-ts");
const _ActionTypes = require("./actionTypes");
//#region LENS
const statusLens = monocle.Lens.fromProp('status');
const validationErrorsLens = monocle.Lens.fromProp('validationErrors');
function default_1(namespace) {
    const ActionTypes = _ActionTypes.default(namespace);
    const initialState = {
        mode: 'CLOSED',
        status: 'STANDBY',
        error: undefined,
        validationErrors: undefined
    };
    const methods = {};
    methods[ActionTypes.OPEN_OVERLAY] = (state, action) => {
        if (action.payload.mode === 'NEW_FOLDER') {
            return Object.assign(Object.assign({}, state), { mode: 'NEW_FOLDER', newFolder: {} });
        }
        if (action.payload.mode === 'DELETE') {
            return Object.assign(Object.assign({}, state), { mode: 'DELETE' });
        }
        if (action.payload.mode === 'TTL') {
            return Object.assign(Object.assign({}, state), { mode: 'TTL', ttl: action.payload.ttl });
        }
        if (action.payload.mode === 'EDIT_SUBPROJECT') {
            return Object.assign(Object.assign({}, state), { file: Object.assign(Object.assign({}, action.payload.file), { name: action.payload.file.name, fileExtension: '' }), mode: 'EDIT_SUBPROJECT' });
        }
        if (action.payload.mode === 'EDIT') {
            const fileRegExp = /(.*)\.([\w\d]+)$/g;
            const file = fileRegExp.exec(action.payload.file.name);
            if (!file || action.payload.file.type === 'FOLDER') {
                return Object.assign(Object.assign({}, state), { file: Object.assign(Object.assign({}, action.payload.file), { name: action.payload.file.name, fileExtension: '' }), mode: 'EDIT' });
            }
            return Object.assign(Object.assign({}, state), { file: Object.assign(Object.assign({}, action.payload.file), { name: file[1], fileExtension: file[2] }), mode: 'EDIT' });
        }
        return Object.assign(Object.assign({}, state), { mode: 'CLOSED' });
    };
    methods[ActionTypes.CLOSE_OVERLAY] = (state, action) => {
        return Object.assign({}, initialState);
    };
    methods[ActionTypes.SET_NEW_FOLDER_NAME] = (state, action) => {
        if (state.mode !== 'NEW_FOLDER') {
            return state;
        }
        return Object.assign(Object.assign({}, state), { newFolder: Object.assign(Object.assign({}, state.newFolder), { name: action.name }) });
    };
    methods[ActionTypes.SET_NEW_FOLDER_DESCRIPTION] = (state, action) => {
        if (state.mode !== 'NEW_FOLDER') {
            return state;
        }
        return Object.assign(Object.assign({}, state), { newFolder: Object.assign(Object.assign({}, state.newFolder), { description: action.description }) });
    };
    methods[ActionTypes.SAVE_PROPERTIES_REQUEST] = (state, action) => {
        return Object.assign(Object.assign({}, state), { validationErrors: undefined, status: 'SAVING' });
    };
    methods[ActionTypes.SAVE_PROPERTIES_FAILURE] = (state, action) => {
        return Object.assign(Object.assign({}, state), { status: 'FAILURE', error: action.payload });
    };
    methods[ActionTypes.SAVE_PROPERTIES_SUCCESS] = (state, action) => {
        return Object.assign(Object.assign({}, state), { status: 'SAVED' });
    };
    methods[ActionTypes.SAVE_NEW_FOLDER_REQUEST] = (state, action) => {
        return Object.assign(Object.assign({}, state), { status: 'SAVING' });
    };
    methods[ActionTypes.SAVE_NEW_FOLDER_SUCCESS] = (state, action) => {
        return Object.assign(Object.assign({}, state), { status: 'SAVED' });
    };
    methods[ActionTypes.SAVE_NEW_FOLDER_FAILURE] = (state, action) => {
        return Object.assign(Object.assign({}, state), { status: 'FAILURE', error: action.payload });
    };
    methods[ActionTypes.DELETE_REQUEST] = (state, action) => {
        return Object.assign(Object.assign({}, state), { status: 'SAVING' });
    };
    methods[ActionTypes.DELETE_SUCCESS] = (state, action) => {
        return Object.assign(Object.assign({}, state), { status: 'SAVED' });
    };
    methods[ActionTypes.DELETE_FAILURE] = (state, action) => {
        return Object.assign(Object.assign({}, state), { status: 'FAILURE' });
    };
    methods[ActionTypes.GET_TTL_REQUEST] = (state, action) => {
        return Object.assign(Object.assign({}, state), { status: 'FETCHING', ttl: null });
    };
    methods[ActionTypes.GET_TTL_SUCCESS] = (state, action) => {
        if (state.mode !== 'TTL') {
            return state;
        }
        return Object.assign(Object.assign({}, state), { status: 'FETCHED', ttl: action.ttl });
    };
    methods[ActionTypes.GET_TTL_FAILURE] = (state, action) => {
        return Object.assign(Object.assign({}, state), { status: 'FAILURE' });
    };
    methods[ActionTypes.SET_TTL_REQUEST] = (state, _action) => {
        return Object.assign(Object.assign({}, state), { status: 'FETCHING' });
    };
    methods[ActionTypes.SET_TTL_SUCCESS] = (state, action) => {
        return Object.assign(Object.assign({}, state), { status: 'FETCHED', ttl: action.ttl });
    };
    methods[ActionTypes.SET_TTL_FAILURE] = (state, _action) => {
        return Object.assign(Object.assign({}, state), { status: 'FAILURE' });
    };
    methods[ActionTypes.VALIDATION_FAILURE] = (state, action) => fp.function.compose(validationErrorsLens.set(action.payload.reduce((rv, x) => {
        ;
        (rv[x.key] = rv[x.key] || []).push(x.value);
        return rv;
    }, {})), statusLens.set('FAILURE'))(state);
    methods[ActionTypes.EDIT_CUSTOM_META] = (state, action) => {
        return Object.assign({}, state);
    };
    methods[ActionTypes.CLEAR] = (state, action) => {
        return Object.assign({}, initialState);
    };
    const reducer = (state = initialState, action) => {
        if (methods[action.type]) {
            return methods[action.type](state, action);
        }
        return state;
    };
    return { reducer, initialState, methods };
}
exports.default = default_1;
//# sourceMappingURL=reducers.js.map